<template>
  <div class="transfer">
    <el-tabs v-model="activeName" :before-leave="beforeLeave">
      <el-tab-pane label="出让方概况" name="tab1" :disabled="tabDisabled.tab1">
        <tab-three
          ref="tab1"
          :id="id"
          :cfrom="data"
          @aChange="activeNameChange"
          @aStagin="staging"
          @aSync="syncData"
        />
      </el-tab-pane>

      <el-tab-pane label="项目基本信息" name="tab2" :disabled="tabDisabled.tab2">
        <tab-one
          ref="tab2"
          :id="id"
          :cfrom="data"
          @aChange="activeNameChange"
          @aStagin="staging"
          @aSync="syncData"
        />
      </el-tab-pane>

      <el-tab-pane label="标的信息" name="tab3" :disabled="tabDisabled.tab3">
        <tab-target-info
          ref="tab3"
          :id="id"
          :cfrom="data"
          @aChange="activeNameChange"
          @aStagin="staging"
          @aSync="syncData"
        />
      </el-tab-pane>

      <el-tab-pane label="交易信息" name="tab4" :disabled="tabDisabled.tab4">
        <tab-four
          ref="tab4"
          :id="id"
          :cfrom="data"
          @aChange="activeNameChange"
          @aStagin="staging"
          @aSync="syncData"
        />
      </el-tab-pane>

      <el-tab-pane label="是否估值或评估" name="tab5" :disabled="tabDisabled.tab5">
        <tab-valuation
          ref="tab5"
          :id="id"
          :cfrom="data"
          @aChange="activeNameChange"
          @aStagin="staging"
          @aSync="syncData"
        />
      </el-tab-pane>

      <el-tab-pane label="附件上传" name="tab6" :disabled="tabDisabled.tab6">
        <tab-attachment
          ref="tab6"
          :id="id"
          :cfrom="data"
          @aChange="activeNameChange"
          @aStagin="staging"
          @aSync="syncData"
        />
      </el-tab-pane>

      <el-tab-pane label="信息发布" name="tab7" :disabled="tabDisabled.tab7">
        <tab-five
          ref="tab7"
          :id="id"
          :cfrom="data"
          :proj-type="projType"
          @aChange="activeNameChange"
          @aStagin="staging"
          @submit="handleSubmit"
          @aSync="syncData"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getRequest, postRequest } from "../../api/api";
import { getUSER } from "../../api/constant";
import tabOne from "./components/tabOne.vue";
import tabThree from "./components/tabThree.vue";
import tabFour from "./components/tabFour.vue";
import tabFive from "./components/tabFive.vue";
import tabValuation from "./components/tabValuation.vue";
import tabTargetInfo from "./components/tabTargetInfo.vue";
import tabAttachment from "./components/tabAttachment.vue";

export default {
  components: {
    tabOne,
    tabThree,
    tabFour,
    tabFive,
    tabValuation,
    tabTargetInfo,
    tabAttachment,
  },
  props: ["cid", "projType"],
  data() {
    return {
      activeName: "tab1",
      id: null,
      data: {},
      tabDisabled: {
        tab1: false,
        tab2: false,
        tab3: false,
        tab4: false,
        tab5: false,
        tab6: false,
        tab7: false,
      },
    };
  },
  methods: {
    staging(eData) {
      this.data = { ...this.data, ...eData };
      const payload = this.buildPayload(this.data);
      postRequest({
        url: `/api/v1/markRelease/save`,
        data: payload,
      }).then((res) => {
        if (res.errcode == 200) {
          this.$message.success("暂存成功");
          if (res.data && res.data.id) {
            this.id = res.data.id;
            this.data = { ...this.data, id: res.data.id };
          }
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
    syncData(eData) {
      if (eData) this.data = { ...this.data, ...eData };
    },
    syncFromTab(tabName) {
      const comp = this.$refs[tabName];
      if (comp && typeof comp.buildValue === "function") {
        this.data = { ...this.data, ...comp.buildValue() };
      }
    },
    beforeLeave(activeName, oldActiveName) {
      this.syncFromTab(oldActiveName);
      return true;
    },
    activeNameChange(n, eData) {
      if (eData) this.data = { ...this.data, ...eData };
      this.activeName = n;
    },
    handleSubmit(eData) {
      if (eData) this.data = { ...this.data, ...eData };
      const payload = this.buildPayload(this.data);
      const user = getUSER() || {};
      const userId = user.id || "";
      postRequest({
        url: `/api/v2/projectStatus/project/submit?draft=0&isFrontend=1&userId=${userId}`,
        data: payload,
      }).then((res) => {
        if (res.errcode == 200) {
          this.$message.success("提交成功");
          this.$router.push({ path: "/my" });
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
    buildPayload(data) {
      const d = { ...data };
      d.projType = this.projType;
      d.isAdmin = 0;
      if (this.id) d.id = this.id;

      // transferorInfos → crfInfos (type=1)
      if (d.transferorInfos && Array.isArray(d.transferorInfos)) {
        d.crfInfos = d.transferorInfos.map((item) => ({ ...item, type: 1 }));
      }

      // licenseCustom: string → 1/0
      if (d.licenseCustom === "是 已自行实施专利技术") {
        d.licenseCustom = 1;
      } else if (d.licenseCustom !== undefined && d.licenseCustom !== null && d.licenseCustom !== "") {
        d.licenseCustom = 0;
      }

      // licenseOther: string → 1/0
      if (d.licenseOther === "是 已许可他人实施专利") {
        d.licenseOther = 1;
      } else if (d.licenseOther !== undefined && d.licenseOther !== null && d.licenseOther !== "") {
        d.licenseOther = 0;
      }

      // licenseTypeCross/Fraction: bool → 0/1
      if (d.licenseTypeCross !== undefined) d.licenseTypeCross = d.licenseTypeCross ? 1 : 0;
      if (d.licenseTypeFraction !== undefined) d.licenseTypeFraction = d.licenseTypeFraction ? 1 : 0;


      return d;
    },
    getXgData(id) {
      getRequest({ url: `/api/v1/markRelease/${id}` }).then((res) => {
        if (res.errcode == 200) {
          const raw = res.data;
          // 字符串 → 数组 (for multi-value fields stored as comma-separated)
          if (typeof raw.dealWay === "string" && raw.dealWay) {
            // keep as string, tabs will parse as needed
          }
          // crfInfos → transferorInfos
          if (raw.crfInfos && Array.isArray(raw.crfInfos)) {
            raw.transferorInfos = raw.crfInfos.filter(
              (item) => item.type == 1 || item.type === "1"
            );
          }
          // licenseCustom: 1/0 → string
          if (raw.licenseCustom === 1 || raw.licenseCustom === "1") {
            raw.licenseCustom = "是 已自行实施专利技术";
          } else if (raw.licenseCustom !== undefined && raw.licenseCustom !== null) {
            raw.licenseCustom = "否";
          }
          // licenseOther: 1/0 → string
          if (raw.licenseOther === 1 || raw.licenseOther === "1") {
            raw.licenseOther = "是 已许可他人实施专利";
          } else if (raw.licenseOther !== undefined && raw.licenseOther !== null) {
            raw.licenseOther = "否";
          }
          this.data = raw;
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
  },
  mounted() {
    if (this.cid) {
      this.id = this.cid;
      this.getXgData(this.id);
    } else if (this.projType === 0) {
      this.data = {
        projType: 0,
        listedTimeEnd: "2",
        releaseTimeEnd: "网络竞价",
        assigneeQualification: "无需提供资信证明",
        theJoint: "本项目不接受联合受让主体",
        isEarnestMoney: "否",
        paymentDemand: "《交易合同》签订之日起  工作日内支付全额交易价款/首期  万元至  账户",
        otherCondition: `1、本项目对外公告之日即进入尽职调查期，意向受让方在本项目公告期间有权利和义务自行对交易标的进行全面了解。
2、意向受让方应在公告期内向上海知识产权交易中心递交受让申请文件。
3、信息发布期满，如只征集到一个符合条件的意向受让方的，按照挂牌价成交；如征集到两个及以上符合条件的意向受让方的，采用网络竞价方式确定受让方和受让价格。
4、为保护交易各方合法利益，申请人在此做出特别提示。
5、本次交易基本服务费自《交易合同》签订之日起 xx 个工作日内由   双方  支付。`,
      };
    }
  },
};
</script>

<style lang="scss" scoped></style>
